(function () {
    'use strict';

    const module = angular.module('imApp');

    module.component('deliveryMethodBusinessco', {
        templateUrl: 'views/components/views/deliveryMethodBusinessco/deliveryMethodBusinessco.template.html?v=' + module.version,
        controllerAs: 'vm',
        controller: ['$stateParams', 'deliveryMethodBusinesscoService', function ($stateParams, deliveryMethodBusinesscoService) {

            // #region VARIABLES & DEFINITIONS

            const vm = this;
        	let deliveryMethodNo = $stateParams.deliverymethod_no;
            
            vm.model = {
                itemsListBusinesses: []
            };

            // #endregion VARIABLES & DEFINITIONS

            // #region LOAD PROCEDURE FUNCTION CALL

            async function loadBusinesses() {
                const list = await deliveryMethodBusinesscoService.listBusinesses({ deliverymethod_no: deliveryMethodNo });

                vm.model.itemsListBusinesses = [];

                list.forEach((item) => {
                    let icon = 'glyphicon-unchecked';

                    if (item.active === '1') {
                        icon = 'glyphicon-check';
                    }

                    if (item.agreement_id === '' && item.internal_driver === '0') {
                        icon = 'glyphicon-ban-circle';
                    }

                    vm.model.itemsListBusinesses.push({
                        item_id: item.deliverymethod_businessco_keyno,
                        item_name: item.company_name,
                        item_agreement_id: item.agreement_id,
                        item_glyphicon: icon,
                        item_active: item.active
                    });
                });
            }

            // #endregion LOAD PROCEDURE FUNCTION CALL

            // #region TOGGLE CHOSEN FUNCTION

            vm.toggleChosen = function (item) {
                if (item.item_agreement_id !== '') {
                    let active = '1';

                    if (item.item_active !== '0') {
                        active = '0';
                    }

                    deliveryMethodBusinesscoService.toggleItems({
                        deliverymethod_businessco_keyno: item.item_id,
                        active: active
                    }).then(function () {
                        vm.model.itemsListCompanies = [];
                        loadBusinesses();
                    });
                }
            };

            // #endregion TOGGLE CHOSEN FUNCTION

            // #region ON INIT FUNCTION

            vm.$onInit = function () {
                loadBusinesses();
            }

            // #endregion ON INIT FUNCTION

        }]
    });
})();
